export interface Breadcrumb {
  name: string;
  url?: string;
}

export enum ActionEnum {
  NONE = 'NONE',
  ASKED = 'ASKED',
  ACCEPTED = 'ACCEPTED',
}

export const reverseAction: Array<string> = [
  ActionEnum.NONE,
  ActionEnum.ASKED,
  ActionEnum.ACCEPTED,
]

export function displayAction(action: string) {
  if (action === ActionEnum.NONE) {
    return "Inte frågat"
  } else if (action === ActionEnum.ASKED) {
    return "Frågat"
  } else if (action === ActionEnum.ACCEPTED) {
    return "Genomfört"
  }
  return action
}

export interface RoomLogInterface {
  outdoor: ActionEnum
  activity: ActionEnum
  roomId: number
  clientId: number
  clientName: string
  date: string
  updatedAt: string
}

export interface TeamInterface {
  id: number,
  name: string,
  rooms: Array<RoomInterface>
}

export interface RoomInterface {
  id: number,
  name: string,
  logs: Array<RoomLogInterface>
}